var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuarantine = function SvgQuarantine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.514 6.586 4.072-4.072h2.828l4.072 4.072v2.828l-4.072 4.072H6.586L2.514 9.414V6.586Zm1 .415v1.998l3.487 3.487h1.998l3.487-3.487V7.001L8.999 3.514H7.001L3.514 7.001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.547 8.688-.156-1.8V5.153l.135-.135h.97l.135.135V6.88l-.157 1.808-.132.132H7.68l-.132-.132Zm-.109 2.095-.135-.135v-1.08l.135-.135h1.124l.135.135v1.08l-.135.135H7.438Z",
    fill: "currentColor"
  })));
};
export default SvgQuarantine;